import React, { useContext } from "react";
import useForm from "../../../../services/UseForm";
import validate from '../../../../validations/admin/basicInfo/currencyValidate';
import '../../../../css/popUpForm.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { CurrencyContext } from "../currency";

axios.defaults.baseURL = API;

function CreateCurrency(props) {

    const {dataList, setDataList} = useContext(CurrencyContext);

    const handleInputCurrencyChange = event => {
        const { name, value } = event.target;
        handleChange(name, value)
        check(value);
    };

    const check = (params) => {
        const results = dataList.filter((data) => {
            return data.Currency.toLowerCase() === params.toLowerCase()
        });
        if (results.length > 0)
            handleChange("CheckCurrency", results[0].Currency);
        else
            handleChange("CheckCurrency", "");
    }

    async function saveTutorial() {
        let token = localStorage.getItem("token");
        var data = {
            Currency: values.Currency,
        }
        await axios.post("/createCurrency", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            var obj = {
                CurrencyID: response?.data?.insertId,
                Currency: values.Currency,
            }
            dataList.push(obj);
            setDataList(dataList);
            localStorage.setItem("currencyData", JSON.stringify(dataList));
            ClearData();
            props.onClick(false);
        }).catch((err) => {
            console.log(err);
        });
    };

    const ClearData = () => 
        handleChange("Currency", "");

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(saveTutorial, validate);

    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="popUpForm">
            <div className="content">
                <div className="Header">
                    <span>ສ້າງສະກຸນເງິນ</span>
                </div>
                <div className="Body">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-row">
                            <div className="col form-group">
                                <span>ສະກຸນເງິນ</span>
                                <input className={`input form-control ${errors.Currency && 'is-invalid'}`} type="text" name="Currency" onChange={(e) => handleInputCurrencyChange(e)} value={values.Currency || ''} required />
                                {errors.Currency && (
                                    <p className="invalid-feedback">{errors.Currency}</p>
                                )}
                            </div>
                        </div>
                        <div className="footer">
                            <button type="submit" className="btn btn-primary">
                                ບັນທຶກ
                            </button>
                            <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                                ກັບຄືນ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateCurrency;
